import React, {Component} from 'react';
import Page from '../../containers/page';

import {Container} from 'reactstrap';
import {connect} from 'react-redux';

import {generateSearchLink, generateSearchLinkMultiple, getSearchParams,} from '../../helpers/linkHelper';
import SelectInput from '../../components/forms/fields/select';
import {API_ENDPOINT} from '../../constants';

class Form extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: false,
            useState: false,
            params: {
                entries: 10,
                page: 0,
            },
            items: [],
            areas: [],
            total: 0,
            loading: true,
            csvList: [],
            menu: [],
            selectedCsv: '',
            isLoading: false,
            processMessage: null,
            processMessageType: null,
        };
    }

    get = () => {
        for (let i = 0; i < this.props.loadData.length; i++) {
            this.props.loadData[i](
                window.fetch,
                this.props.lang,
                this.props[0].match,
                this.state.useState
                    ? this.state.params
                    : getSearchParams(this.props[0].location.search, {
                        entries: 10,
                        page: 0,
                    }),
            ).then((data) => {
                this.setState(
                    {
                        ...data,
                        loading: null,
                    },
                    () => {
                        this.props.updateMeta(
                            this.props.generateSeoTags(this.state, this.props.lang),
                        );
                    },
                );
            });
        }

        for (let i = 0; i < this.props.loadDataWithQuery.length; i++) {
            this.props.loadDataWithQuery[i](
                window.fetch,
                this.props.lang,
                this.props[0].match,
                this.state.useState
                    ? this.state.params
                    : getSearchParams(this.props[0].location.search, {
                        entries: 10,
                        page: 0,
                    }),
            ).then((data) => {
                this.setState(
                    {
                        ...data,
                        loading: null,
                    },
                    () => {
                        this.props.updateMeta(
                            this.props.generateSeoTags(this.state, this.props.lang),
                        );
                    },
                );
            });
        }
    };

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }

        if (
            this.props[0].location &&
            this.props[0].location.state &&
            this.props[0].location.state.page
        ) {
            this.setState({lastPage: this.props[0].location.state.page});
        }

        this.get();
    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState(
                {
                    loading: true,
                },
                () => {
                    this.get();
                },
            );
        }
    }

    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field;
            state.sortType = type;
            this.setState({
                params: state,
            });
        } else {
            this.props[0].history.push(
                generateSearchLinkMultiple(
                    this.props[0].location.search,
                    {entries: 10, page: 0},
                    [
                        {name: 'sortField', value: field},
                        {name: 'sortType', value: type},
                    ],
                    false,
                ),
            );
        }
    };

    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0,
                };
                obj[name] = value;
                this.setState({params: obj});
            } else {
                let obj = this.state.params;
                obj[name] = value;
                this.setState({params: obj});
            }
        } else {
            this.props[0].history.push(
                generateSearchLink(
                    this.props[0].location.search,
                    {entries: 10, page: 0},
                    name,
                    value,
                    restart,
                ),
            );
        }
    };

    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0,
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({params: obj});
            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({params: obj});
            }
        } else {
            this.props[0].history.push(
                generateSearchLinkMultiple(
                    this.props[0].location.search,
                    {entries: 10, page: 0},
                    fields,
                    restart,
                ),
            );
        }
    };

    retriggerFetching = () => {
        fetch(API_ENDPOINT + `/data/shop/csv`, {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((res) => res.json())
            .then((csv) => {
                this.setState({
                    csvList: [...csv.filter((item) => item !== 'template.csv')],
                });
            });
    };

    selectCsvHandler = (csv) => {
        this.setState({selectedCsv: csv});
    };
    deleteCsvHandler = () => {
        fetch(API_ENDPOINT + `/data/shop/csv/${this.state.selectedCsv}`, {
            method: 'DELETE',
            headers: {
                'content-type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
        })
            .then((res) => res.text())
            .then((csv) => {
                this.retriggerFetching();
                this.setState({selectedCsv: ''});
            });
    };


    processCsvHandler = () => {
        const bodyObject = {
            fileName: this.state.selectedCsv,
        };
        this.setState({ isLoading: true, processMessage: null, processMessageType: null });
        fetch(API_ENDPOINT + '/data/shop/csv/process', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('authToken')}`,
            },
            body: JSON.stringify(bodyObject),
        })
            .then((res) => res.json().then((body) => ({ status: res.status, body })))
            .then(({ status, body }) => {
                let messageType = 'success';
                let message = '';

                if (status === 200) {
                    const inserted = body && typeof body.inserted === 'number' ? body.inserted : 0;
                    const skipped = body && typeof body.skipped === 'number' ? body.skipped : 0;
                    const total = body && typeof body.total === 'number' ? body.total : 0;

                    if (inserted === 0 && skipped > 0) {
                        messageType = 'warning';
                        message = `Nije dodat nijedan artikal — svih ${skipped} redova su duplikati koji već postoje u bazi.`;
                    } else {
                        messageType = 'success';
                        message = `Fajl obrađen. Dodato: ${inserted}, preskočeno duplikata: ${skipped}, ukupno redova: ${total}.`;
                    }
                } else {
                    messageType = 'error';
                    message = (body && body.message) || 'Greška prilikom obrade CSV fajla.';
                }

                this.setState({
                    isLoading: false,
                    selectedCsv: '',
                    processMessage: message,
                    processMessageType: messageType,
                });
            })
            .catch(() => {
                this.setState({
                    isLoading: false,
                    processMessage: 'Greška u komunikaciji sa serverom.',
                    processMessageType: 'error',
                });
            });
    };
    selectFile = (e) => {
        let input = e.target;
        if (input.files && input.files[0]) {
            this.setState({
                isLoading: true,
            });

            let formData = new FormData();
            formData.append('file', input.files[0]);

            fetch(API_ENDPOINT + '/upload-csv', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: formData,
            })
                .then((res) => res.text())
                .then((csv) => {
                    this.setState({
                        isLoading: false,
                    });
                    this.retriggerFetching();
                    input.value = '';
                });
        }
    };

    render() {
        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, {
                entries: 10,
                page: 0,
            });
        }

        const marko = this.props.uData._id === '6507e98d1baf6373b920aa34';
        return (
            <div className='page '>
                <Container className='dashboard'>
                    <div className=' bg-white component p-4'>
                        <div className={'row m-0'}>
                            <div className='d-flex justify-content-between w-100'>
                                <h4 className=' section-new-title '>Obrada csv fajlova</h4>
                                {this.props &&
                                    this.props.uData &&
                                    (this.props.uData._id === '66cedc8605a7690233663100' ||
                                        this.props.uData._id === '603e55228b8e6e6cebc33f04' ||
                                        marko) && (
                                        <a
                                            className={'btn btn-success'}
                                            href={`${API_ENDPOINT}/uploads/csv/template.csv`}
                                        >
                                            Preuzmi template
                                        </a>
                                    )}
                            </div>
                        </div>
                        <div className='row pt-5'>
                            <div className='col col-6'>
                                <label className='select-title'>Lista csv fajlova</label>
                                <SelectInput
                                    values={this.state.csvList}
                                    placeholder={'Izaberite csv za obradu'}
                                    onChange={this.selectCsvHandler}
                                    value={this.state.selectedCsv}
                                ></SelectInput>
                            </div>
                            <div className='col col-6'>
                                <label className='select-title'>Dodaj novi csv</label>
                                <div className='invisible-input-wrapper'>
                                    <span> Izaberi csv fajl za upload </span>
                                    <input
                                        className='w-100 '
                                        type={'file'}
                                        accept={'.csv'}
                                        onChange={this.selectFile}
                                    />
                                </div>
                            </div>
                            <div className='col col-12 d-flex align-items-center'>
                                <button
                                    disabled={!this.state.selectedCsv || this.state.isLoading}
                                    className={`btn btn-danger ${this.state.selectedCsv ? '' : 'cursor-default'}`}
                                    onClick={this.deleteCsvHandler}
                                >
                                    Obriši
                                </button>
                                <button
                                    disabled={!this.state.selectedCsv || this.state.isLoading}
                                    className={`btn btn-info mx-2  ${this.state.selectedCsv ? '' : 'cursor-default'}`}
                                    onClick={this.processCsvHandler}
                                >
                                    {this.state.isLoading && (
                                        <div className={'spinner-border mr-2'}></div>
                                    )}
                                    Procesuj
                                </button>
                                {this.props &&
                                    this.props.uData &&
                                    (this.props.uData._id === '66cedc8605a7690233663100' ||
                                        this.props.uData._id === '603e55228b8e6e6cebc33f04' ||
                                        marko) && (
                                        <a
                                            className={`btn btn-dark  ${this.state.selectedCsv ? '' : 'cursor-default'} ${!this.state.selectedCsv && 'disabled'}`}
                                            href={`${API_ENDPOINT}/uploads/csv/${this.state.selectedCsv}`}
                                        >
                                            Preuzmi csv
                                        </a>
                                    )}
                            </div>
                            {this.state.processMessage && (
                                <div className='col col-12 mt-3'>
                                    <div
                                        className={`alert ${
                                            this.state.processMessageType === 'success'
                                                ? 'alert-success'
                                                : this.state.processMessageType === 'warning'
                                                ? 'alert-warning'
                                                : 'alert-danger'
                                        }`}
                                        role='alert'
                                    >
                                        {this.state.processMessage}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </Container>
            </div>
        );
    }
}

export default connect((state) => {
    return {};
}, {})(Page(Form));
